import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { toast } from "sonner";

export default function AdminLogin() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const user = await login(email, password);
      if (user.role !== "admin") { toast.error("Not an admin account"); return; }
      nav("/admin");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin min-h-screen flex items-center justify-center bg-background px-6">
      <div className="w-full max-w-sm bg-card rounded-2xl border border-border p-8">
        <div className="text-center mb-6">
          <div className="font-display text-2xl font-extrabold text-primary">BODYCRUSH</div>
          <p className="text-xs uppercase tracking-[0.3em] text-muted-foreground">Admin Console</p>
        </div>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="text-sm text-foreground">Email</label>
            <input value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-email" required
              className="mt-1.5 w-full rounded-xl bg-secondary border border-input px-3 py-2.5 text-sm text-foreground outline-none focus:border-primary" />
          </div>
          <div>
            <label className="text-sm text-foreground">Password</label>
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-password" required
              className="mt-1.5 w-full rounded-xl bg-secondary border border-input px-3 py-2.5 text-sm text-foreground outline-none focus:border-primary" />
          </div>
          <button disabled={loading} className="w-full bg-primary text-primary-foreground rounded-full py-3 font-semibold disabled:opacity-60" data-testid="admin-login-btn">
            {loading ? "Signing in…" : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
